import ROUTES from "./routes";

export const EMPTY_REVIEW_COUNTS = {
  homeworks: 0,
  exams: 0,
  challenges: 0,
  notifications: 0,
  total: 0,
};

export const REVIEW_POLL_INTERVAL_MS = 60_000;

export const REVIEW_ITEMS = [
  {
    key: "homeworks",
    label: "تکالیف",
    description: "ارسال‌های در انتظار تصحیح",
    path: ROUTES.TEACHER_ASSIGNMENTS,
    accent: "#00AFA8",
    background: "rgba(0, 175, 168, 0.08)",
  },
  {
    key: "exams",
    label: "آزمون‌ها",
    description: "آزمون‌های در انتظار بررسی",
    path: ROUTES.TEACHER_ACTIVE_TESTS,
    accent: "#D97706",
    background: "rgba(217, 119, 6, 0.08)",
  },
  {
    key: "challenges",
    label: "چالش‌ها",
    description: "چالش‌های در انتظار بررسی",
    path: ROUTES.TEACHER_CHALLENGES,
    accent: "#914985",
    background: "rgba(145, 73, 133, 0.08)",
  },
  {
    key: "notifications",
    label: "اعلان‌ها",
    description: "اعلان‌های خوانده‌نشده",
    path: ROUTES.TEACHER_SCHOOL_NOTIFICATIONS,
    accent: "#2563EB",
    background: "rgba(37, 99, 235, 0.08)",
    requiresNotifications: true,
  },
];

function toCount(value) {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? Math.floor(number) : 0;
}

export function normalizeReviewCounts(data) {
  const homeworks = toCount(data?.homeworks);
  const exams = toCount(data?.exams);
  const challenges = toCount(data?.challenges);
  const notifications = toCount(data?.notifications);
  const total = toCount(data?.total) || homeworks + exams + challenges + notifications;

  return { homeworks, exams, challenges, notifications, total };
}

export function getVisibleReviewItems(counts = EMPTY_REVIEW_COUNTS, { canUseNotifications = true } = {}) {
  return REVIEW_ITEMS.filter((item) => !item.requiresNotifications || canUseNotifications).map((item) => ({
    ...item,
    count: toCount(counts[item.key]),
  }));
}

export function getVisibleReviewTotal(counts = EMPTY_REVIEW_COUNTS, options) {
  return getVisibleReviewItems(counts, options).reduce((sum, item) => sum + item.count, 0);
}

export function formatReviewCount(value, { compact = false } = {}) {
  const count = toCount(value);

  if (compact && count > 99) {
    return "۹۹+";
  }

  return new Intl.NumberFormat("fa-IR").format(count);
}
